module.exports = __webpack_public_path__ + "img/cosmo.b112aa80.png";